<div class="apm-card dashboard-card hover-shadow shadow" (click)="onCardClick($event)">
  <div class="w-100">
    @if (showProject()) {
      @if (energyAnalyses().projectCode) {
        <div class="text-md bold mb-1">{{ energyAnalyses().projectCode }}</div>
      }
      @if (energyAnalyses().projectTitle) {
        <div class="text-md bold mb-2 text-truncate">{{ energyAnalyses().projectTitle }}</div>
      }
    }
    <div class="text-md bold d-flex align-items-center justify-content-between mb-2">
      <span [class.fst-italic]="showProject()">
        {{ energyAnalyses().name !== '' ? energyAnalyses().name : 'Untitled' }}
      </span>
      <div class="d-flex align-items-center">
        @if (energyAnalyses().systemUsageType.id === '1' || energyAnalyses().systemUsageType.id === '3') {
          <apm-icon size="xs" icon="o_snowflake"></apm-icon>
        }
        @if (energyAnalyses().systemUsageType.id === '2' || energyAnalyses().systemUsageType.id === '3') {
          <apm-icon class="ms-1" size="xs" icon="o_flame"></apm-icon>
        }
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-2">
      @if (energyAnalyses().locked) {
        <apm-fa-icon icon="lock" [active]="true" iconSize="md" matTooltip="{{ '451636' | apmTranslate }}"></apm-fa-icon>
      } @else {
        <apm-fa-icon icon="lock-open" [active]="true" iconSize="md" />
      }
      @if (matchingSegment$ | async; as segment) {
        <div class="px-2 fw-bold text-white" [ngStyle]="{ background: segment.color }">
          {{ segment.description }}
        </div>
      }
    </div>
    <hr class="gray-divider-1" />
    <div class="created-by-info mt-2">
      @if (energyAnalyses().createdAt) {
        <span class="created-at italic">
          {{ '444876' | apmTranslate }} - {{ energyAnalyses().createdAt | momentDate: 'DD/MM/YYYY - HH:mm' }}
        </span>
      }
      @if (energyAnalyses().updatedAt) {
        <span class="created-at italic">
          {{ '444979' | apmTranslate }} - {{ energyAnalyses().updatedAt | momentDate: 'DD/MM/YYYY - HH:mm' }}
        </span>
      }
    </div>
  </div>
  <div class="mb-2">
    <hr class="gray-divider-1" />
    <span class="d-block my-2">
      @if (systemsCount() === 0) {
        {{ '451615' | apmTranslate }}
      } @else if (systemsCount() === 1) {
        {{ systemsCount() }} {{ '451616' | apmTranslate }}
      } @else if (systemsCount() > 1) {
        {{ systemsCount() }} {{ '451619' | apmTranslate }}
      }
    </span>
    <hr class="gray-divider-1" />
    <div class="d-flex flex-nowrap align-items-center mt-3">
      <apm-icon size="xxs" icon="o_pin"></apm-icon>
      <div class="italic-2 ps-1">
        @if (energyAnalyses().city?.name) {
          <span> {{ countryLabel() }}, {{ cityLabel() }} </span>
        }
      </div>
    </div>
  </div>
</div>
